import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { initReactI18next } from "react-i18next";

import {
  FALLBACK_LANGUAGE,
  GUEST_MENU_NAMESPACE,
  LANGUAGE_QUERY_PARAM,
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
  isSupportedLanguage,
} from "./languages";
import de from "./locales/de.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";

/** Own instance, not the global singleton: the dashboard renders these components
 * in its theme preview with no i18n setup, and would show raw keys. */
export const guestMenuI18n = i18next.createInstance();

guestMenuI18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { [GUEST_MENU_NAMESPACE]: en },
      fr: { [GUEST_MENU_NAMESPACE]: fr },
      it: { [GUEST_MENU_NAMESPACE]: it },
      es: { [GUEST_MENU_NAMESPACE]: es },
      de: { [GUEST_MENU_NAMESPACE]: de },
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: FALLBACK_LANGUAGE,
    ns: [GUEST_MENU_NAMESPACE],
    defaultNS: GUEST_MENU_NAMESPACE,
    // "fr-CA" and the like should resolve to "fr" rather than falling back to English.
    load: "languageOnly",
    detection: {
      // Not cached: a shared `?lang=` link would otherwise pin this browser to
      // that language at every restaurant with no in-app way back. Add caching
      // with a picker, not before.
      order: ["querystring", "navigator"],
      lookupQuerystring: LANGUAGE_QUERY_PARAM,
      caches: [],
    },
    // Gated on this option, not NODE_ENV, so it would ship to guests.
    showSupportNotice: false,
    interpolation: {
      // React already escapes rendered values.
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export const currentLanguage = (): SupportedLanguage => {
  const resolved = guestMenuI18n.resolvedLanguage ?? guestMenuI18n.language;
  return isSupportedLanguage(resolved) ? resolved : FALLBACK_LANGUAGE;
};

export const changeLanguage = (language: SupportedLanguage) =>
  guestMenuI18n.changeLanguage(language);

/** Pinned to one language, sharing the resource store, so one page can render several. */
export const createPinnedInstance = (language: SupportedLanguage) =>
  guestMenuI18n.cloneInstance({ lng: language, detection: { order: [] } });
